import { faUser } from "@fortawesome/free-solid-svg-icons";
import React from "react";

import { IEfilingMessage } from "../../../config/interfaces";
import { UtilService } from "../../../services";
import FASvgIcon from "../../FASvgIcon";

type Props = { message: IEfilingMessage };

const UserSideMessage: React.FC<Props> = (props: Props) => {
	const { message } = props;

	return (
		<div className={`chat-msg user-msg`} key={`user-msg ${message.id}`}>
			<div className="user-icon">
				<FASvgIcon icon={faUser} />
			</div>
			<div className="user-message">
				<h5 className="user-info">
					{message?.efilingMessageCreatedBy?.fullName || ""}
					<small>{UtilService.getTimeDisplay(message.createdAt)}</small>
				</h5>
				<div className="msg-content">
					<p>{message?.message?.text}</p>
				</div>
			</div>
		</div>
	);
};
export default UserSideMessage;
